import Vue from 'vue';
import store from '../vuex/store.js';
import jQuery from "jquery";

class RestApiManager {
    userId      = window.wpguppy_scripts_vars.userId;
    recordLimit = Number(window.wpguppy_scripts_vars.showRec);
    getGroupMemberList( isScrolling , search = ''){
        let offset = store.state.groupMemberOffset;
        let noMoreGroupMemeber  = store.state.noMoreGroupMemeber;
        let groupMemberFlag     = store.state.groupMemberFlag;

        if( !noMoreGroupMemeber ) {
            store.commit('updateListFlag', {flag: 'isScrollList', flagValue:true});
            Vue.axios.get(
                'get-guppy-group-users?offset=' +
                offset + '&search=' + search + '&userId=' + this.userId
                ).then( response => {
                store.commit('updateListFlag', {flag: 'isScrollList', flagValue:false});
                let currentRecord = response.data.guppyGroupUsers.length == 0 ? true : false;
                store.commit('updateRecordList', {RecordList: 'noMoreGroupMemeber', RecordListValue: currentRecord});
                if(!groupMemberFlag){
                    store.commit('updateListFlag', {flag: 'groupMemberFlag', flagValue:true});
                    store.state.initGroupMembers = response.data.guppyGroupUsers;
                }

                let data = {
                    'list'      : response.data.guppyGroupUsers,
                    'listType'  : 'groupMembers',
                    'isScrolling' : isScrolling
                }
                
                store.commit('updateRecList', data)
            }).catch(error => {
                console.log(error)
                store.commit('updateListFlag', {flag: 'isScrollList', flagValue:false});
            });

            let currentOffset = offset + this.recordLimit;
            store.commit('updateOffset', {offset:'groupMemberOffset', offsetValue: currentOffset});
        }
    }

    async getConversation(offset, search, chatType){
        try {
            return await Vue.axios.get( "load-guppy-messages-list?userId="+this.userId+"&offset=" + offset + '&search='+ search + '&chatType=' + chatType);
        } catch(error){
            console.log(error);
            return error;
        }
    }

    async getUsersList(offset,search = '') {
        try {
            return await Vue.axios.get("load-guppy-users?userId="+this.userId+"&offset="+offset+'&search='+search)
        } catch(error){
            console.log(error);
            return error;
        }
    }
    async getFriendRequestsList(offset,search = '') {
        try {
            return await Vue.axios.get("load-guppy-friend-requests?userId="+this.userId+"&offset="+offset+'&search='+search)
        } catch(error){
            console.log(error);
            return error;
        }
    }
    async getContactList( offset, friendStatus, search = '' ) {
        try {
            return await Vue.axios.get('load-guppy-contacts?userId='+this.userId+'&offset=' + offset + '&search=' + search+'&friendStatus=' + friendStatus)
        } catch(error){
            console.log(error);
            return error;
        }
    }
    async getpostList( offset, search = '' ) {
        try {
            return await Vue.axios.get( "load-guppy-post-messages-list?userId="+this.userId+"&offset=" + offset + '&search='+search )
        } catch(error){
            console.log(error);
            return error;
        }
    }

    async sendMessage( data, chatId = '' ){
        jQuery('.at-replay_upload').removeClass('at-uploadoption_open');
         let userName           = ''; 
        let userAvatar          = '';
        let chatInfo            = new Object();
        if(store.state.isMessangerChat){
            chatInfo = {...store.state.chatInfo};
        } else {
            chatInfo = {...store.state.chatInfo[chatId]};
        }
        
        let muteNotification    = chatInfo.muteNotification;
        if(chatInfo.chatType == 0 || chatInfo.chatType == 1){
            userName    = chatInfo.userName;
            userAvatar  = chatInfo.userAvatar;
        } 
        try {
        let response = await Vue.axios.post('send-guppy-message', data);
          if( response.data.type == 'success' ){
            let chatResponce = JSON.parse(JSON.stringify(response.data.chatData));
                chatResponce["isSender"] = true;
            store.commit("appendMessage", chatResponce);
            let messagelistData = JSON.parse(JSON.stringify(response.data.messagelistData));
            let chatData        = JSON.parse(JSON.stringify(response.data.chatData));
            let chatType        = response.data.chatType;
            let groupMembers    = [];
            let userId          = 0;
            if(chatType == 2){
              groupMembers  =  response.data.groupMembers;
              userId        = this.userId;
            }
            let payload = { chatData, messagelistData, groupMembers, userName, userAvatar, userId, chatType, muteNotification }
            store.dispatch('triggerSocketEvents', {'event':'sendMessage', payload});
          }
          return response.data
        } catch( error ) {
            this.errors = error;
            return error;
        }
    }
    getUnReadMessages(){
        Vue.axios.get('load-unread-count?userId='+this.userId).then(response=>{
          store.commit('unseenCountMessage', response.data.unReadContent);
        }).catch(error=>{
          console.log(error);
        });
    }
    async muteNotification(data){
        try {
            let response = await Vue.axios.post( "mute-guppy-notifications", data );
            if( response.data.type == 'success'){
                let payload = {
                    muteType : data.muteType,
                    chatType : data.chatType,
                    chatId   : data.chatId,
                    isMute   : ( response.data.muteAll == '1') ? true : false,
                    userId   : this.userId
                };
                store.commit('updateMuteChatNotify', payload);
                store.dispatch('triggerSocketEvents', {'event':'updateMuteChatNotify', payload});
            }
            return response;
        } catch(error){
            console.log(error);
            return error;
        }
    }
}

export default new RestApiManager;